import React, { PureComponent } from "react";
import { connect } from "react-redux";
import classnames from "classnames";
import styles from "./FicheClient.local.scss";
import { AttachmentIcon, ICONS, SvgIcon } from "../Common/Icons";
import _ from "i18n";
import DropDownActionsList from "../Common/DropDown/DropDownActionsList";
import browserHistory from "history/createBrowserHistory";
import SettingPageHeader from "../Common/PageHeader/SettingPageHeader";
import {
  saveAccountingDates,
  saveBalance,
  fetchBalanceSheet,
  fetchFicheClient
} from "Thunks";
import { push } from "react-router-redux";
import { BALANCE_MODELS_CONFIG } from "Config";
import {
  setBalanceOrganization,
  initBalance,
  setAccountingDates,
  setStartDate,
  setModelConfig,
  setBalanceSheetOrganization,
  setOrganizationsList,
  setBalanceSheetModel,
  setOrganizationListFilterTitle
} from "Actions";
import {
  generateAccountingDates,
  recalculateAccountingMonths,
  onSuccess,
  onError,
  compareAccountingDates
} from "Utils";
import { Tooltip } from "antd";
import BalanceUpload from "../BalanceUpload/BalanceUpload";
import NotFoundV2 from "../NotFound/NotFoundV2";
import {
  folderRolesCollaborator,
  folderRolesManager,
  formatUen,
  inIframe
} from "../../utils";
import { ModalConfirm } from "tamtam-components";
import { TTPReactModal } from "../Common/Modal/TTPReactModal";
import stylesButton from "../Common/Modal/Button.local.scss";
import { isClientAccess } from "Utils";
import { NotificationBar } from "../Common/Notification/NotificationBar";

class HeaderFicheClient extends PureComponent {
  constructor(props) {
    super(props);
    let uen = browserHistory().location.pathname.split("/");
    this.state = {
      organizationUen: uen[2],
      loading: false,
      loadingBalance: false,
      loadingAnnexe: false,
      visible: false,
      slide: 1,
      dashboardId: 4,
      isOpenModal: false,
      year: this.props.selectedYear
    };
    this.carousel = React.createRef();
  }
  componentDidMount() {
    const { dispatch, currentPage, synchro, selectedYear } = this.props;
    const { organizationUen } = this.state;
    dispatch(setOrganizationListFilterTitle(organizationUen));
    dispatch(fetchFicheClient(organizationUen, synchro, selectedYear));
    if (currentPage !== "BALANCE_SHEET") {
      dispatch(setBalanceSheetModel("STANDARD"));
      dispatch(fetchBalanceSheet(organizationUen));
    }
  }

  handleError = () => {
    const { error } = this.props;

    if (error.code === 170043) {
      return (
        <NotFoundV2
          errorPageType={"ACCESS_DENIED"}
          text={"noBalanceImportedMessage"}
          buttonIgnored={1}
        />
      );
    } else if (error.code === 170060) {
      return (
        <NotFoundV2
          errorPageType={"ACCESS_DENIED"}
          text={`${_("accessDenied")} : ${_("dashboardNotFound")}`}
          buttonIgnored={1}
        />
      );
    } else {
      return (
        <NotFoundV2
          errorPageType={"ACCESS_DENIED"}
          text={"errorOccured"}
          buttonIgnored={1}
        />
      );
    }
  };

  renderDropDownMenuActions = organizationUen => {
    return (
      <ul className="menu drop-down-option__left default drop-down-option--show">
        <li>
          <a
            className={""}
            href={`https://data.be/en/company/${organizationUen}`}
            target="_blank"
          >
            <img
              src={"/img/external-icons/data_be-logo.png"}
              alt={""}
              style={{ height: 15 }}
            />
            Data.be
          </a>
        </li>
        <li>
          <a
            className={""}
            href={`https://kbopub.economie.fgov.be/kbopub/zoeknummerform.html?lang=fr&nummer=${organizationUen}&actionLu=Recherche`}
            target="_blank"
          >
            <img
              src={"/img/external-icons/crossroads_bank_for_companies-logo.png"}
              alt={""}
              style={{ height: 15, marginLeft: -6 }}
            />
            Crossroads Bank for Companies
          </a>
        </li>
        <li>
          <a
            className={""}
            href={`http://www.ejustice.just.fgov.be/cgi_tsv/tsv_rech.pl?language=fr&btw=${organizationUen}&liste=Liste`}
            target="_blank"
          >
            <img
              src={"/img/external-icons/spf_justice-logo.png"}
              alt={""}
              style={{ height: 15 }}
            />
            SPF Justice
          </a>
        </li>
        <li>
          <a
            className={""}
            href={`https://consult.cbso.nbb.be/consult-enterprise/${organizationUen}`}
            target="_blank"
          >
            <img
              src={"/img/external-icons/national_bank-logo.png"}
              alt={""}
              style={{ height: 15 }}
            />
            National Bank
          </a>
        </li>
        <li>
          <a
            className={""}
            href={`https://www.socialsecurity.be/app014/wrep/rep_gp.do?language=fr&REP_KEY_VALUE=${organizationUen}&ACCESS_TYPE=0&ACTION=1&REP_KEY_TYPE=12&REP_LIMIT_DATE=`}
            target="_blank"
          >
            <img
              src={"/img/external-icons/social_security-logo.png"}
              alt={""}
              style={{ height: 15 }}
            />
            Social Security
          </a>
        </li>
      </ul>
    );
  };

  next = () => {
    this.carousel.current.next();
    this.setState({
      slide: 2
    });
    this.handleUpdateModelConfigOnCanImport();
  };

  previous = () => {
    if (this.carousel && this.carousel.current)
      this.carousel.current.goTo(0, false);
    this.setState({
      slide: 1
    });
  };

  nextToAnnexeUpload = () => {
    this.carousel.current.next();
    this.setState({
      slide: 3
    });
  };

  backToBalanceUpload = () => {
    this.carousel.current.prev();
    this.setState({
      slide: 2
    });
  };

  isAccountingDatesGenerated = () => {
    return !(
      this.props.startDate &&
      this.props.accountingDates[0] &&
      this.props.accountingDates[0].months
    );
  };

  handleSaveAccountingDates = () => {
    this.setState({ loading: true });
    this.props.dispatch(saveAccountingDates()).then(
      res => {
        this.onSuccessSaveAccountingDates(res);
        this.setState({ loading: false });
        this.next();
      },
      err => this.onErrorSaveAccountingDates(err)
    );
  };

  onSuccessSaveAccountingDates = res => {
    let { balance, organizationsList } = this.props;

    let list = organizationsList.slice();
    // eslint-disable-next-line array-callback-return
    list.map(item => {
      if (item.id === balance.organization.id) {
        item.accountingDates = this.props.accountingDates;
        item.startDate = this.props.startDate;
        item.stats.configuredExercises = this.props.accountingDates.length;
      }
    });
    this.props.dispatch(setOrganizationsList(list));

    let organization = { ...balance.organization };
    organization.accountingDates = this.props.accountingDates;
    organization.startDate = this.props.startDate;
    this.props.dispatch(setBalanceOrganization(organization));

    onSuccess(res, {
      body: _("updateExercices"),
      title: _("saveSuccess")
    });
  };

  onErrorSaveAccountingDates = err => {
    this.setState({ loading: false });
    onError(err);
  };

  handleSaveBalance = () => {
    const { organizationUen, year } = this.state;
    this.setState({ loadingBalance: true });
    this.props.dispatch(saveBalance()).then(
      res => {
        this.setState({ loadingBalance: false, visible: false });
        this.previous();
        onSuccess(res, {
          body: _("importBalanceSuccess"),
          title: _("importSuccess")
        });
        this.props.dispatch(push(`/balance-sheet/${organizationUen}/${year}`));
      },
      error => {
        this.setState({ loadingBalance: false });
        onError(
          this.renderErrorText(
            error.response.data.errors && error.response.data.errors[0].code
          )
        );
      }
    );
  };

  renderErrorText = code => {
    switch (code) {
      case 170020:
      case 170021:
        return (
          <span
            dangerouslySetInnerHTML={{
              __html: _("incorrectFile")
            }}
          />
        );
      case 170030:
        return (
          <span
            dangerouslySetInnerHTML={{
              __html: _("incompatibleModel")
            }}
          />
        );

      default:
        return <span>{_("errorOccured")}</span>;
    }
  };

  canImport = () => {
    const { accountingDates, organization, startDate } = this.props;
    return !(
      organization &&
      organization.accountingDates &&
      startDate === organization.startDate &&
      compareAccountingDates(accountingDates, organization.accountingDates)
    );
  };

  handleUpdateModelConfigOnCanImport = () => {
    const { accountingDates, balance } = this.props;
    const { sourceModel } = balance;
    let years = BALANCE_MODELS_CONFIG[sourceModel].years,
      modelConfig = [];
    // modelConfig = {
    //   years: []
    // };

    if (sourceModel === "kluwer_compared_model") {
      for (let i = 0; i < accountingDates.length; i++) {
        modelConfig.push(accountingDates[i].year);
      }
    } else if (years <= accountingDates.length) {
      for (let i = 0; i < years; i++) {
        modelConfig.push(accountingDates[i].year);
        // modelConfig.years.push(accountingDates[i].year);
      }
    }

    this.props.dispatch(setModelConfig(modelConfig));
  };

  // ****  Balance Upload Modal (functions) END **** //

  // ****  Balance Upload Modal (render) **** //

  renderModalFooterBalanceAccountingConfig = () => {
    return [
      <button
        key="back"
        className={stylesButton.back}
        onClick={this.handleCancel}
      >
        {_("cancel")}
      </button>,
      <button
        key="submit"
        className={stylesButton.save}
        onClick={this.handleSaveAccountingDates}
        disabled={this.isAccountingDatesGenerated()}
      >
        {this.state.loading && (
          <img
            src={"/img/icons/tail-spin.svg"}
            alt={""}
            className={stylesButton.loading}
          />
        )}
        {_("save")}
      </button>,
      <button
        key="next"
        className={stylesButton.import}
        onClick={this.next}
        disabled={this.canImport()}
      >
        {_("import")}
      </button>
    ];
  };

  renderModalFooterBalanceModels = () => {
    return [
      <button key="back" className={stylesButton.back} onClick={this.previous}>
        {_("return")}
      </button>,
      <button
        key="submit"
        className={stylesButton.import}
        style={{ width: "13.520rem" }}
        onClick={this.handleSaveBalance}
        disabled={
          // this.props.balance.modelConfig.length &&
          !this.props.balance.balanceAttachment
          /*   ? false
            : true*/
        }
      >
        {this.state.loadingBalance && (
          <img
            src={"/img/icons/tail-spin-green.svg"}
            alt={""}
            className={stylesButton.loading}
          />
        )}
        {_("importBalance")}
      </button>
    ];
  };

  // ****  Balance Upload Modal (render) END **** //

  // ****  Balance Sheet Viewer functions **** //

  handleDisplayBalanceSheetViewer = organization => {
    this.props.dispatch(setBalanceSheetOrganization(organization));
    this.props.dispatch(
      push(`/balance-sheet/${organization.uen}/${this.state.year}`)
    );
  };

  // ****  Balance Sheet Viewer (functions) END **** //

  // ****  Dashboard functions **** //

  handleShowModal = organization => {
    this.setState({
      visible: true,
      slide: 1
    });

    this.props.dispatch(initBalance());
    this.props.dispatch(setBalanceOrganization(organization));
    this.props.dispatch(
      setStartDate(organization.startDate ? organization.startDate : null)
    );
    this.props.dispatch(
      setAccountingDates(
        organization.accountingDates
          ? organization.accountingDates
          : organization.startDate
            ? recalculateAccountingMonths(
                organization.startDate,
                generateAccountingDates(
                  organization.startDate,
                  new Date().getFullYear() - 1 + "-12-31"
                )
              )
            : [
                {
                  accountingDate: new Date().getFullYear() - 1 + "-12-31"
                }
              ]
      )
    );
  };

  handleOk = (visible = false) => {
    this.setState({ loading: true });
    setTimeout(() => {
      this.setState({ loading: false, visible: visible });
      visible ? this.next() : this.previous();
    }, 3000);
  };

  handleCancel = () => {
    if (this.canImport()) {
      this.setState({ isOpenModal: true });
    } else {
      this.setState({ visible: false });
      this.previous();
    }
  };

  handleBilanPage = () => {
    const { dispatch } = this.props;
    const { organizationUen, year } = this.state;
    dispatch(push(`/balance-sheet/${organizationUen}/${year}`));
  };
  handlePreparePresentationPage = () => {
    const { dispatch, organizations } = this.props;
    const { organizationUen } = this.state;
    let organization = organizations.filter(
      item => item.organization.uen === organizationUen
    )[0];
    dispatch(
      push(
        "/prepare-presentation/" +
          organizationUen +
          "?year=" +
          organization.accountingDates[0].year
      )
    );
  };
  handleDashboardPage = () => {
    const { dispatch } = this.props;
    const { organizationUen, year } = this.state;
    // let organization = organizations.filter(
    //   item => item.organization.uen === organizationUen
    // )[0];

    // if (
    //   organization &&
    //   organization.accountingDates &&
    //   organization.accountingDates.length > 0
    // ) {
    //   dispatch(
    //     push(
    //       "/dashboard/" +
    //         organizationUen +
    //         "?year=" +
    //         organization.accountingDates[0].year
    //     )
    //   );
    // } else {
    dispatch(push("/dashboard/" + organizationUen + "/" + year));
    // }
  };
  handlePlayPage = () => {
    const { dispatch, organizations } = this.props;
    const { organizationUen } = this.state;
    let organization = organizations.filter(
      item => item.organization.uen === organizationUen
    )[0];
    dispatch(
      push(
        "/diaporama/" +
          organizationUen +
          "?year=" +
          organization.accountingDates[0].year
      )
    );
  };
  handleFicheClientPage = () => {
    const { dispatch } = this.props;
    const { organizationUen, year } = this.state;
    dispatch(push(`/fiche-client/${organizationUen}/${year}`));
  };
  handleAnnexesPage = () => {
    const { dispatch } = this.props;
    const { organizationUen, year } = this.state;
    dispatch(push("/Annexes/" + organizationUen + "/" + year));
  };

  handleRedirectBack = () => {
    this.props.dispatch(setOrganizationListFilterTitle(""));
    this.props.dispatch(push("/folders/"));
  };

  renderOrganizationNameFetching() {
    return (
      <div className="medium-3">
        <div
          className={classnames(
            styles.list_item__header,
            styles.name__fetching
          )}
        >
          <h3 className={styles.gradiant} />
        </div>
        <div
          className={classnames(
            styles.list_item__sub_header,
            styles.name__fetching
          )}
        >
          <h4 className={styles.gradiant} />
        </div>
      </div>
    );
  }

  renderFoldersRolesFetching() {
    return (
      <div className={classnames(styles.role_folder, styles.fetching)}>
        <h3 className={styles.gradiant}> </h3>
        <h3 className={styles.gradiant}> </h3>
        <h3 className={styles.gradiant}> </h3>
      </div>
    );
  }
  render() {
    const {
      organizations,
      currentPage,
      balance,
      loggedAs,
      spaceAs,
      user,
      currentOrganization,
      synchro,
      years,
      selectedYear,
      portail
    } = this.props;
    const { organizationUen, isOpenModal } = this.state;
    let organization = organizations.filter(
      item => item.organization.uen === organizationUen
    )[0];
    return (
      <div>
        {inIframe() === false && (
          <div style={{ marginBottom: "10px" }}>
            <NotificationBar
              message={_("notifyUsingUa")}
              isUaNotification={true}
              theme="lightOrange"
            />
          </div>
        )}
        {!isClientAccess(currentOrganization, portail) ? (
          <SettingPageHeader
            title={_("clientForm")}
            onBack={() => this.handleRedirectBack()}
            organizationName={
              organization ? organization.organization.name : ""
            }
            handleChangeYear={value => this.props.handleChangeYear(value)}
            isSynchro={synchro}
            years={years}
            selectedYear={selectedYear}
            currentPage={currentPage}
          />
        ) : (
          ""
        )}

        <div className={classnames(styles.header)}>
          <div className={styles.list_item}>
            {this.props.fetching && this.renderOrganizationNameFetching()}
            {!this.props.fetching && (
              <div className="medium-3">
                {organization && (
                  <div className={styles.list_item__header}>
                    {organization && organization.organization.name}
                    {organization && organization.organization.legalForm
                      ? " (" + organization.organization.legalForm + ")"
                      : ""}
                  </div>
                )}
                <div className={styles.list_item__sub_header}>
                  {organization && formatUen(organization.organization.uen)}
                </div>
              </div>
            )}
            <div className={`medium-4 ${styles.list_item__key}`}>
              {this.props.fetching && this.renderFoldersRolesFetching()}
              {!this.props.fetching && (
                <div className={styles.role_folder}>
                  {organization &&
                    ((loggedAs === "MANAGER" && spaceAs === "COLLABORATOR") ||
                      loggedAs === "COLLABORATOR") &&
                    folderRolesCollaborator(
                      organization.roleCollab,
                      user && user.id
                    )}
                  {organization &&
                    loggedAs === "MANAGER" &&
                    spaceAs === "MANAGER" &&
                    folderRolesManager(organization.roleCollab)}
                </div>
              )}
              <div className={styles.config_list}>
                <div className={styles.buttons}>
                  {!isClientAccess(currentOrganization, portail) ? (
                    <Tooltip
                      placement="top"
                      title={_("configuration")}
                      mouseLeaveDelay={0}
                    >
                      <div
                        className={classnames(styles.butt, styles.config_butt)}
                        onClick={() => {
                          this.handleShowModal(organization);
                        }}
                      >
                        <SvgIcon
                          icon={ICONS.SETTING}
                          className={"icon_setting"}
                        />
                      </div>
                    </Tooltip>
                  ) : (
                    ""
                  )}

                  <div
                    className={classnames(
                      styles.butt,
                      styles.external_link_butt
                    )}
                  >
                    <DropDownActionsList
                      visible={true}
                      fiche={true}
                      shortId={this.state.organizationUen}
                      renderDropDownMenuActions={() =>
                        this.renderDropDownMenuActions(
                          this.state.organizationUen
                        )
                      }
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className={`large-5 medium-6 ${styles.list_item__key}`}>
              <div className={styles.config_button}>
                <div className={styles.buttons}>
                  <Tooltip
                    placement="top"
                    title={_("clientForm")}
                    mouseLeaveDelay={0}
                  >
                    <div
                      className={classnames(
                        styles.butt,
                        styles.home_butt,
                        currentPage === "FICHECLIENT"
                          ? styles.active_home_butt
                          : ""
                      )}
                      onClick={() => {
                        this.handleFicheClientPage();
                      }}
                    >
                      <div className={styles.test}>
                        <SvgIcon icon={ICONS.HOME} />
                        <span>
                          <div>{_("home")}</div>
                        </span>
                      </div>
                    </div>
                  </Tooltip>
                  <Tooltip
                    placement="top"
                    title={_("dashboard")}
                    mouseLeaveDelay={0}
                  >
                    <div
                      className={classnames(
                        styles.butt,
                        styles.config_butt,
                        currentPage === "DASHBOARD"
                          ? styles.active_home_butt
                          : ""
                      )}
                      onClick={this.handleDashboardPage}
                    >
                      <div className={styles.test}>
                        <SvgIcon icon={ICONS.DASHBOARD_PAGE_ICON} />
                        <span>
                          <div>{_("dashboard")}</div>
                        </span>
                      </div>
                    </div>
                  </Tooltip>{" "}
                  <Tooltip
                    placement="top"
                    title={_("balanceSheet")}
                    mouseLeaveDelay={0}
                  >
                    <div
                      className={classnames(
                        styles.butt,
                        styles.config_butt,
                        currentPage === "BALANCE_SHEET"
                          ? styles.active_home_butt
                          : ""
                      )}
                      onClick={this.handleBilanPage}
                    >
                      <div className={styles.test}>
                        <SvgIcon
                          icon={ICONS.BALANCE_SHEET_PAGE_ICON}
                          className={""}
                        />
                        <span>
                          <div>{_("balanceSheet")}</div>
                        </span>
                      </div>
                    </div>
                  </Tooltip>
                  <Tooltip
                    placement="top"
                    title={_("files")}
                    mouseLeaveDelay={0}
                  >
                    <div
                      className={classnames(
                        styles.butt,
                        styles.config_butt,
                        currentPage === "ANNEXES" ? styles.active_home_butt : ""
                      )}
                      onClick={this.handleAnnexesPage}
                    >
                      <div className={styles.test}>
                        <AttachmentIcon fill={"#6D7F92"} size={12} />
                        <span>
                          <div>{_("files")}</div>
                        </span>
                      </div>
                    </div>
                  </Tooltip>
                </div>
              </div>
            </div>
          </div>
          <TTPReactModal
            title={`${_("configureOrganization")}
            ${balance.organization &&
              balance.organization.organization &&
              balance.organization.organization.name &&
              balance.organization.organization.name.toUpperCase()}`}
            isOpen={this.state.visible}
            inProcess={this.state.loading}
            onConfirm={this.handleOk}
            onCancel={this.handleCancel}
            width={700}
            footer={
              this.state.slide === 1
                ? this.renderModalFooterBalanceAccountingConfig()
                : this.renderModalFooterBalanceModels()
            }
          >
            <BalanceUpload
              carouselRef={this.carousel}
              handleNextToAnnexeUpload={this.nextToAnnexeUpload}
              handleBackToBalanceUpload={this.backToBalanceUpload}
              handleSaveBalance={this.handleSaveBalance}
              loadingBalance={this.state.loadingBalance}
            />
          </TTPReactModal>
          <ModalConfirm
            type={"return"}
            isOpen={isOpenModal}
            onCancel={() => this.setState({ isOpenModal: false })}
            onConfirm={() => {
              this.setState({ visible: false });
              this.previous();
              this.setState({ isOpenModal: false });
            }}
            inProcess={false}
            actionFailed={false}
            title={_("cancelConfirm")}
            text={_("cancelConfirmContent")}
            labelNo={_("cancel")}
            labelYes={_("exit")}
            labelError={"Error"}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  fetching: state.organizations.list.fetching,
  fetched: state.organizations.list.fetched,
  user: state.auth.user,
  organizationsList: state.organizations.list.items,
  balance: state.balance,
  organization: state.balance.organization,
  selectedClients: state.organizations.list.selected,
  accountingDates: state.balance.accountingDates,
  startDate: state.balance.startDate,
  lng: state.params.lng,
  organizations: state.organizations.list.items,
  loggedAs: state.auth.loggedAs,
  spaceAs: state.auth.spaceAs,
  error: state.balanceSheet.error,
  currentOrganization: state.auth.currentOrganization,
  withoutHeader: state.auth.withoutHeader,
  synchro: state.fiduciary.data && state.fiduciary.data.synchro,
  portail: state.auth.portail
});

export default connect(mapStateToProps)(HeaderFicheClient);



// WEBPACK FOOTER //
// ./src/components/FicheClient/HeaderFicheClient.js